import { Component, OnInit, Input, ChangeDetectorRef, } from '@angular/core';
import { EmailRowComponent } from "./email-row/email-row.component";
import { Email } from "../../@core/data/email"
import { EmailService } from "../../@core/api/email.service"
import { NbWindowService, NbWindowState } from '@nebular/theme';
import { EmailNewComponent } from "../email-new/email-new.component"
import { LenguageService } from '../../@core/utils/lenguage.service'
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-email-table',
  templateUrl: './email-table.component.html',
  styleUrls: ['./email-table.component.scss']
})
export class EmailTableComponent implements OnInit {

  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  emails: Email[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0
  }
  order = {
    field: "timestamp",
    direction: "desc"
  }
  range: any;
  selectedRowId: string;
  addFilter: boolean = false;
  dateRange: {
    dateStart: number,
    dateEnd: number,
  }

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private emailService: EmailService,
    public language: LenguageService
  ) {

  }

  async ngOnInit() {

    this.getEmails();

  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getEmails();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getEmails();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getEmails() {
    this.loading = true;
    this.emails = <Email[]>await this.emailService.getEmails(this.pagination, this.filters, this.order);
    this.loading = false;

    if (this.emails.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }

  }


  async createEmail() {
    this.loading = true;
    let res = <any>await this.emailService.createEmail({ name: "nuova email", html: "empty", structure: { "empty": true } });
    this.loading = false;
    console.log(res)
    this.router.navigate(["home","email", res.id])

  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = new Date(this.range.start).getTime() * 1000 / 1000;
    this.filters.dateRange = { dateStart, dateEnd };

  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getEmails();
  }

}
